import React from "react";
import { PropTypes } from "prop-types";
import { smallLarge } from "./iconConstants";
import { themes } from "../../theme";

const ticketIcons = {
  small: (color, children, props) => (
    <svg
      {...props}
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      {children}
      <defs>
        <polygon id="path-1" points="16 0 0 0 0 16 16 16" />
      </defs>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g>
          <mask id="mask-2" fill="white">
            <use xlinkHref="#path-1" />
          </mask>
          <g
            mask="url(#mask-2)"
            fill={color}
            {...color !== "currentColor" && { fillOpacity: ".65" }}
            fillRule="nonzero"
          >
            <g transform="translate(8.251948, 8.031508) rotate(-45.000000) translate(-8.251948, -8.031508) translate(0.751948, 3.031508)">
              <path d="M9.96544565,8.54220706 L13.1895679,8.54220706 L13.1145405,6.47963002 L12.8921748,6.4055081 C12.1214593,6.14860293 11.6016054,5.42734418 11.6016054,4.61493869 C11.6016054,3.80253319 12.1214593,3.08127445 12.8921748,2.82436927 L13.1163787,2.74963464 L13.1868401,1.05692569 L9.96544565,1.05692569 L9.96544565,1.97113925 C9.96544565,2.24728163 9.74158803,2.47113925 9.46544565,2.47113925 C9.18930328,2.47113925 8.96544565,2.24728163 8.96544565,1.97113925 L8.96544565,1.05692569 L1.48016428,1.05692569 L1.48016428,8.54220706 L8.96544565,8.54220706 L8.96544565,7.6279935 C8.96544565,7.35185113 9.18930328,7.1279935 9.46544565,7.1279935 C9.74158803,7.1279935 9.96544565,7.35185113 9.96544565,7.6279935 L9.96544565,8.54220706 Z M13.2084025,3.77305257 C12.8460292,3.8938437 12.6016054,4.2329636 12.6016054,4.61493869 C12.6016054,4.99691377 12.8460292,5.33603367 13.2084025,5.4568248 L13.7597192,5.64059704 C13.9575607,5.70654417 14.093694,5.88835762 14.1012749,6.09676294 L14.1889069,8.50585556 C14.1894577,8.52402731 14.1894577,8.52402731 14.1895679,8.54220706 C14.1895679,9.09449181 13.7418526,9.54220706 13.1895679,9.54220706 L1.48016428,9.54220706 C0.927879529,9.54220706 0.480164278,9.09449181 0.480164278,8.54220706 L0.480164278,1.05692569 C0.480164278,0.50464094 0.927879529,0.0569256897 1.48016428,0.0569256897 L13.1868401,0.0569256897 C13.2076413,0.0570699303 13.2076413,0.0570699303 13.2284305,0.0577909457 C13.7802374,0.0807607017 14.2089446,0.54670923 14.1859749,1.09851611 L14.1011727,3.1357339 C14.0925392,3.3431385 13.9566509,3.52363644 13.7597192,3.58928034 L13.2084025,3.77305257 Z M3.8085914,3.88535281 C3.53244903,3.88535281 3.3085914,3.66149519 3.3085914,3.38535281 C3.3085914,3.10921044 3.53244903,2.88535281 3.8085914,2.88535281 L6.63701853,2.88535281 C6.9131609,2.88535281 7.13701853,3.10921044 7.13701853,3.38535281 C7.13701853,3.66149519 6.9131609,3.88535281 6.63701853,3.88535281 L3.8085914,3.88535281 Z M5.22280497,6.71377994 C4.94666259,6.71377994 4.72280497,6.48992231 4.72280497,6.21377994 C4.72280497,5.93763756 4.94666259,5.71377994 5.22280497,5.71377994 L6.63701853,5.71377994 C6.9131609,5.71377994 7.13701853,5.93763756 7.13701853,6.21377994 C7.13701853,6.48992231 6.9131609,6.71377994 6.63701853,6.71377994 L5.22280497,6.71377994 Z M8.96544565,4.0924596 C8.96544565,3.81631722 9.18930328,3.5924596 9.46544565,3.5924596 C9.74158803,3.5924596 9.96544565,3.81631722 9.96544565,4.0924596 L9.96544565,5.50667316 C9.96544565,5.78281553 9.74158803,6.00667316 9.46544565,6.00667316 C9.18930328,6.00667316 8.96544565,5.78281553 8.96544565,5.50667316 L8.96544565,4.0924596 Z" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  large: (color, children, props) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      {children}
      <g fill="none" fillRule="evenodd">
        <path d="M24 0H0v24h24z" />
        <path
          fill={color}
          {...color !== "currentColor" && { fillOpacity: ".65" }}
          fillRule="nonzero"
          d="M18.006 4.528a1.03 1.03 0 0 0 1.457 1.457l.332-.332a.5.5 0 0 1 .707 0l3.14 3.14a1 1 0 0 1 0 1.414L10.207 23.642a1 1 0 0 1-1.415 0L.307 15.156a1 1 0 0 1 0-1.414L13.742.307a1 1 0 0 1 1.414 0l3.182 3.182a.5.5 0 0 1 0 .707l-.332.332zM14.45 1.014L1.014 14.45 9.5 22.935 22.935 9.499l-2.786-2.785a2.03 2.03 0 0 1-2.871-2.871l-2.829-2.829zM10.56 4.196a.5.5 0 1 1 .707-.707L13.39 5.61a.5.5 0 1 1-.708.708l-2.12-2.122zM7.732 14.803a.5.5 0 1 1-.707-.707l4.95-4.95a.5.5 0 1 1 .706.707l-4.95 4.95zm4.242 0a.5.5 0 1 1-.707-.707l2.829-2.829a.5.5 0 1 1 .707.707l-2.829 2.829zm2.122-7.071a.5.5 0 1 1 .707-.707l2.121 2.12a.5.5 0 1 1-.707.708l-2.121-2.121zm3.535 3.535a.5.5 0 1 1 .707-.707l2.122 2.121a.5.5 0 1 1-.707.708l-2.122-2.122z"
        />
      </g>
    </svg>
  )
};

const TicketIcon = ({ size, color, children, ...props }) =>
  ticketIcons[size](color, children, props);

TicketIcon.displayName = "TicketIcon";

TicketIcon.propTypes = {
  children: PropTypes.node,
  size: PropTypes.oneOf(smallLarge),
  color: PropTypes.string
};

TicketIcon.defaultProps = {
  children: null,
  size: smallLarge[1],
  color: themes.global.gray01
};

export default TicketIcon;
